import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { GroupFilters, GroupListRequest } from 'types'

import { groupCount, groupGet, groupList } from './group.service'

export const groupKeyFactory = {
  base: () => ['groups'],
  list: (request?: GroupListRequest) => [
    ...groupKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  count: (filters?: GroupFilters) => [
    ...groupKeyFactory.base(),
    'count',
    ...(filters ? [filters] : []),
  ],
  get: (uuid: string) => [...groupKeyFactory.base(), 'get', uuid],
}

export const queryGroupList = (request: GroupListRequest) =>
  queryOptions({
    queryKey: groupKeyFactory.list(request),
    queryFn: () => groupList(request),
    placeholderData: keepPreviousData,
  })

export const queryGroupCount = (filters?: GroupFilters) =>
  queryOptions({
    queryKey: groupKeyFactory.count(filters),
    queryFn: () => groupCount(filters),
    placeholderData: keepPreviousData,
  })

export const queryGroupGet = (uuid: string) =>
  queryOptions({
    queryKey: groupKeyFactory.get(uuid),
    queryFn: () => groupGet(uuid),
  })
